import React, { useMemo} from "react";
import {
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Divider,
} from "@mui/material";

function getBulkTagResult(apiResponse) {
  const successList = apiResponse?.newDigitalTags || [];
  const failedList = apiResponse?.failedTags || [];

  const successCount = successList.length;
  const failedCount = failedList.length;
  const total = successCount + failedCount;


  return {
    successList,
    failedList,
    successCount,
    failedCount,
    total
  };
}

export function BulkDigitalTagsResult({ apiResponse, open, onClose }) {

  const result = useMemo(() => getBulkTagResult(apiResponse), [apiResponse]);



  return (
    <>
    
      <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
        <DialogTitle>Bulk Import Digital Tags Result</DialogTitle>

        <DialogContent dividers>
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={2}
            mb={2}
            flexWrap="wrap"
          >
            <Chip label={`Total: ${result.total}`} />
            <Chip label={`Success: ${result.successCount}`} color="success" />
            <Chip label={`Failed: ${result.failedCount}`} color="error" />
          </Stack>

          <Divider sx={{ mb: 2 }} />
{ result?.successList?.length > 0 && <>
          <Typography variant="h6" gutterBottom>
            Successful Tags
          </Typography>

          <TableContainer component={Paper} variant="outlined" sx={{ mb: 3 }}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>MAC Address</TableCell>
                  <TableCell>Rotation</TableCell>
                  <TableCell>Status</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {result.successList.length ? (
                  result.successList.map((item, index) => (
                    <TableRow key={item.id || `${item.macAddress}-${index}`}>
                      <TableCell>{item.name || "-"}</TableCell>
                      <TableCell>{item.macAddress || "-"}</TableCell>
                      <TableCell>{item.customProperties?.rotation || "-"}</TableCell>
                      <TableCell>{"success"}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={4} align="center">
                      No successful tags
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          </>
}

{ result?.failedList?.length > 0 && <>
          <Typography variant="h6" gutterBottom>
            Failed Tags
          </Typography>

          <TableContainer component={Paper} variant="outlined">
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>MAC Address</TableCell>
                  <TableCell>Rotation</TableCell>
                  <TableCell>Reason</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {result.failedList.length ? (
                  result.failedList.map((item, index) => (
                    <TableRow key={`${item.macAddress}-${index}`}>
                      <TableCell>{item.name || "-"}</TableCell>
                      <TableCell>{item.macAddress || "-"}</TableCell>
                      <TableCell>{item.customProperties?.rotation || "-"}</TableCell>
                      <TableCell sx={{whiteSpace:"nowrap"}}>Device is already mapped to another tenant or site</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={4} align="center">
                      No failed tags
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
              </>
}
        </DialogContent>

        <DialogActions>
          <Button 
          onClick={onClose}
           variant="contained"
           sx={{
                        textTransform: "none",
                        background: "linear-gradient(90deg, rgb(58,130,150), rgb(63,88,111))",
                        color: "#fff",
                        boxShadow: "none",
                        "&:hover": {
                          background: "linear-gradient(90deg, rgb(58,130,150), rgb(63,88,111))",
                          opacity: 0.95,
                          boxShadow: "none"
                        },
                        "&.Mui-disabled": {
                          background: "linear-gradient(90deg, rgb(58,130,150), rgb(63,88,111))",
                          opacity: 0.5,
                          color: "#fff"
                        }
                      }}
           >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}